import { CreatePaymentStatus } from '@/store/slices/stagesSlice/interfaces'
import { useEffect, useState } from 'react'

type Status = CreatePaymentStatus | 'exhausted'

type UseFetchPaymentStatusArgs = {
  fetchData: () => void
  status: Status
  setStatus: (status: Status) => void
}

export function useFetchPaymentStatus({ fetchData, status, setStatus }: UseFetchPaymentStatusArgs) {
  const [countRequests, setCountRequests] = useState<number>(0)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null
    let mc = countRequests ? 3000 : 0
    if (status === 'pending' && countRequests < 5) {
      timeoutId = setTimeout(() => {
        setCountRequests(pr => pr + 1)
        fetchData()
      }, mc)
    }

    if (countRequests >= 5) {
      setStatus('exhausted')
    }

    return () => {
      timeoutId && clearTimeout(timeoutId)
    }
  }, [status, fetchData, countRequests, setCountRequests])
}
